import api, { checkTokenErrorResponse } from '..';

export function postAcademyDocument(documento, nome) {
    const formdata = new FormData();
    formdata.append('documento', documento);
    formdata.append('nome', nome);

    return api.post("academia_documentos/", formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export function getAcademyDocument() {
    return api.get("academia_documentos/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export function deleteAcademyDocument(documentoId) {
    return api.delete(`academia_documentos/${documentoId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export function postStudentDocument(studentId, documento, nome) {
    const formdata = new FormData();
    formdata.append('documento', documento);
    formdata.append('nome', nome);

    return api.post(`alunos/${studentId}/documentos/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export function getStudentDocument(studentId) {
    return api.get(`alunos/${studentId}/documentos/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export function deleteStudentDocument(studentId, documentId) {
    return api.delete(`alunos/${studentId}/documentos/${documentId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}


const documentsServices = {
    postAcademyDocument,
    getAcademyDocument,
    deleteAcademyDocument,
    postStudentDocument,
    getStudentDocument,
    deleteStudentDocument
}
export default documentsServices;